function addStyles(win, styles) {
    styles.forEach(style => {
        let link = win.document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('type', 'text/css');
        link.setAttribute('href', style);
        win.document.getElementsByTagName('head')[0].appendChild(link);
    });
}

const VueHtmlToPaper = {
    methods: {
        htmlToPaper(el) {

            const element = document.getElementById(el);

            if (!element) {
                alert(`Element to print #${el} not found!`);
                return;
            }

            const win = window.open("", '_blank');

            win.document.write(`
              <html>
                <head>
                  <title>${document.title}</title>
                </head>
                <body>
                  ${element.innerHTML}
                </body>
              </html>
            `);

            addStyles(win, [
                'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                'https://unpkg.com/kidlat-css/css/kidlat.css'
            ]);

            setTimeout(() => {
                win.document.close();
                win.focus();
                win.print();
                win.close();
                // cb();
            }, 1000);
            return true;
        }
    }
}

export default VueHtmlToPaper;